import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles((theme) => ({
  root: {
    background: theme.palette.grey['100'],
    borderRadius: '4px',
    boxShadow: theme.shadows[1],
  },
  quickview: {
    width: '40%',
  },
  header: {
    background: '#596375',
    color: 'white',
  },
  title: {
    fontSize: '1rem',
    padding: '0 1rem',
  },
  closeButton: {
    lineHeight: '1rem',
    padding: '0.8rem',
    cursor: 'pointer',
    '&:hover': {
      opacity: '0.6',
      background: 'rgba(0, 0, 0, 0.5)',
    },
  },
  container: {
    padding: '1rem',
  },
  tabsRoot: {
    background: '#fff',
    minHeight: '28px',
  },
  tabsIndicator: {
    backgroundColor: '#eee',
    height: '100%',
    zIndex: 1,
    borderRadius: '4px 4px 0 0',
  },
  scrollButton: {
    flex: '0 0 32px',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  tabRoot: {
    color: '#818B9D',
    borderRadius: '4px 4px 0 0',
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: 400,
    '&:hover': {
      color: '#818B9D',
      opacity: 1,
    },
    '&:focus': {
      color: '#192542',
    },
    '&$tabSelected': {
      color: '#192542',
      fontWeight: 500,
      boxShadow: theme.shadows[1],
    },
  },
  tabSelected: {},
  label: {
    position: 'relative',
    zIndex: 2,
    fontSize: 16,
  },
  tabPanel: {
    padding: 16,
    borderRadius: 4,
    backgroundColor: '#eee',
    fontSize: 14,
    '& p': {
      fontWeight: 500,
    },
  },
  customer: {
    padding: '0 16px',
    fontSize: 14,
    fontWeight: 400,
    '& span': {
      fontWeight: 500,
    },
  },
  '@media (min-width: 992px)': {
    quickview: {
      maxWidth: 430,
    },
  },
  '@media (max-width: 1024px)': {
    quickview: {
      width: '100%',
    },
  },
}));

export default useStyle;
